// extracted by mini-css-extract-plugin
module.exports = {"container":"Account_container__2tyNb","left":"Account_left__2F1m3","right":"Account_right__2rk6S"};